// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-iam-procedures.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-iam-procedures',
  title:
    'Maintain comprehensive documented IAM procedures including RBAC, MFA, SSO and IAM solutions',
  description:
    'The organisation must maintain documented access management procedures covering: information classification; handling of legal and contractual access obligations; access control schemes (role-based access control); account administration — creation, modification and deletion of user and service accounts, and assignment, modification and removal of access rights; access control mechanisms including passwords, tokens and biometrics; logon processes such as SSO and MFA; and identity and access management (IAM) solutions.',
  category: 'access',
  scfIds: ['SCF-IAM-001', 'SCF-IAM-004'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Comprehensive IAM procedures document is published',
    },
    { type: 'document-approved', description: 'Procedures have been approved' },
    { type: 'document-within-sla', description: 'Procedures review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
